import { getRandomInt, ONE, ZERO } from '@atomica.co/utils';

type Rotate = 'none' | 'right' | 'left';

export const getRotate = (): Rotate => {
  const num = getRandomInt(2);

  switch (num) {
    case ZERO:
      return 'right';
    case ONE:
      return 'left';
    default:
      return 'none';
  }
};
